// extracted by mini-css-extract-plugin
export default {"wrapper":"SkeletonCardPlant_wrapper__KoKog"};